import React from 'react'
import { Follow } from 'react-twitter-widgets'

const FollowMe = () => {
    return (
        <Follow username="gregparr" />
    )
}

export default FollowMe